/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import '../../styles/global.css'
import { type ReactNode } from 'react'
import { usePathname } from 'lib/i18n/routing'
import Globals from './component'
import PostHogProviderAppRouter from 'components/posthog-provider/app-router'
import { LocaleProvider } from '@hashicorp/mds-react/utils'
import { useLocale } from 'next-intl'
import aa from 'search-insights'
import {
	API_KEY,
	APP_ID,
} from 'app/_components/faceted-search/utils/search-client'

aa('init', {
	appId: APP_ID,
	apiKey: API_KEY,
})

interface Props {
	children: ReactNode
}

export default function AppGlobals({ children }: Props) {
	const pathname = usePathname()
	const locale = useLocale()

	return (
		<PostHogProviderAppRouter>
			<LocaleProvider locale={locale}>
				<Globals pathname={pathname}>{children}</Globals>
			</LocaleProvider>
		</PostHogProviderAppRouter>
	)
}
